var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C6.93913 7 5.92172 7.42143 5.17157 8.17157C4.42143 8.92172 4 9.93913 4 11V21C4 22.0609 4.42143 23.0783 5.17157 23.8284C5.92172 24.5786 6.93913 25 8 25H18C19.0609 25 20.0783 24.5786 20.8284 23.8284C21.5786 23.0783 22 22.0609 22 21V20L25.6 22.7C25.8229 22.8671 26.0878 22.9689 26.3653 22.9939C26.6427 23.019 26.9217 22.9662 27.1708 22.8416C27.42 22.7171 27.6295 22.5256 27.776 22.2886C27.9224 22.0516 28 21.7786 28 21.5V10.5C28 10.2214 27.9224 9.94837 27.776 9.7114C27.6295 9.47444 27.42 9.28294 27.1708 9.15836C26.9217 9.03378 26.6427 8.98104 26.3653 9.00606C26.0878 9.03108 25.8229 9.13286 25.6 9.3L22 12V11C22 9.93913 21.5786 8.92172 20.8284 8.17157C20.0783 7.42143 19.0609 7 18 7H8ZM22 14.5L26 11.5V20.5L22 17.5V14.5ZM20 11V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H8C7.46957 23 6.96086 22.7893 6.58579 22.4142C6.21071 22.0391 6 21.5304 6 21V11C6 10.4696 6.21071 9.96086 6.58579 9.58579C6.96086 9.21071 7.46957 9 8 9H18C18.5304 9 19.0391 9.21071 19.4142 9.58579C19.7893 9.96086 20 10.4696 20 11Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOutline);
export default __webpack_public_path__ + "static/media/videoOutline.6078d5dd275b310d9e3ef79af804f182.svg";
export { ForwardRef as ReactComponent };